import { render, staticRenderFns } from "./DashboardActivePages.vue?vue&type=template&id=7b100b43&scoped=true"
import script from "./DashboardActivePages.vue?vue&type=script&lang=js"
export * from "./DashboardActivePages.vue?vue&type=script&lang=js"
import style0 from "./DashboardActivePages.vue?vue&type=style&index=0&id=7b100b43&prod&lang=scss&scoped=true"
import style1 from "./DashboardActivePages.vue?vue&type=style&index=1&id=7b100b43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b100b43",
  null
  
)

export default component.exports